<template>
  <div class="layout-default">
    <!-- <div class="layout-default__auth-container container">
      <AuthManager />
    </div> -->
    <router-view />
  </div>
</template>

<script>
// import AuthManager from "@/components/profile/auth/AuthManager";

export default {
  name: "LayoutDefault",
  components: {
    // AuthManager
  }
};
</script>

<style lang="scss">
.layout-default {
  &__auth-container {
    margin-bottom: 20px;
  }

  @include breakpoint("md-and-down") {
    &__auth-container {
      margin-bottom: 0;
    }
  }
}
</style>
